// src/pages/ClientData/components/ProcessesSection.js
import React from 'react';
import CollapsibleSection from './CollapsibleSection';
import ProcessCard from './ProcessCard';

const ProcessesSection = ({
  processes,
  processDetails,
  processDetailLoading,
  processDetailErrors,
  onLoadDetail,
  movements,
  movementsLoading,
  movementsErrors,
  onLoadMovements,
  movementFiles,
  movementFilesLoading,
  movementFilesErrors,
  onLoadFiles,
  fileTranscriptions,
  fileTranscriptionLoading,
  fileTranscriptionErrors,
  fileSaving,
  onSetFileTranscriptionText,
  onTranscreverFicheiro,
  onSalvarFicheiro
}) => {
  if (!processes || processes.length === 0) return null;

  return (
    <CollapsibleSection
      title="Processos"
      icon="🗂️"
      badge={`${processes.length} processo${processes.length > 1 ? 's' : ''}`}
      defaultOpen={false}
    >
      {processes.map((processo) => {
        const codigoProcesso = processo['Cod. Processo'];
        return (
          <ProcessCard
            key={codigoProcesso}
            processo={processo}
            detail={processDetails[codigoProcesso]}
            detailLoading={processDetailLoading[codigoProcesso]}
            detailError={processDetailErrors[codigoProcesso]}
            onLoadDetail={onLoadDetail}
            movimentosState={movements[codigoProcesso]}
            movementsLoading={movementsLoading[codigoProcesso]}
            movementsError={movementsErrors[codigoProcesso]}
            onLoadMovements={onLoadMovements}
            movementFiles={movementFiles}
            movementFilesLoading={movementFilesLoading}
            movementFilesErrors={movementFilesErrors}
            onLoadFiles={onLoadFiles}
            fileTranscriptions={fileTranscriptions}
            fileTranscriptionLoading={fileTranscriptionLoading}
            fileTranscriptionErrors={fileTranscriptionErrors}
            fileSaving={fileSaving}
            onSetFileTranscriptionText={onSetFileTranscriptionText}
            onTranscreverFicheiro={onTranscreverFicheiro}
            onSalvarFicheiro={onSalvarFicheiro}
          />
        );
      })}
    </CollapsibleSection>
  );
};

export default ProcessesSection;
